/* !
 * jQuery index v1.0.0
 * Copyright 2022, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';

	const mainVisSlider = () => {
		$('.top-main').find('.__slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 1000,
			autoplay: true,
			autoplaySpeed: 4000,
			infinite: true,
			arrows: false,
			dots: false,
			fade: true,
		});
		$('.top-main').find('.__slider').on('beforeChange', (event, slick, currentSlide, nextSlide) => {
			slick.$slides.removeClass('slick-slide-prev');
			for (let i = 0; i < slick.$slides.length; i++) {
				let $slide = $(slick.$slides[i]);
				if ($slide.hasClass('slick-current')) {
					$slide.addClass('slick-slide-prev');
					break;
				}
			}
		});
	};
	const newsBanner = () => {
		if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.desktop) {
			$('.js-newsBanner').find('.__close').on('click', () => {
				$('.js-newsBanner').remove();
			});
		} else {
			$('.__banner_slider').slick({
				slidesToShow: 2,
				slidesToScroll: 1,
				speed: 600,
				autoplay: true,
				autoplaySpeed: 5000,
				infinite: true,
				dots: false,
				arrows: true,
				pauseOnFocus: false,
				pauseOnHover: false,
				pauseOnDotsHover: false,
				prevArrow: '<button type="button" class="slick-prev"><svg><use xlink:href="/common/svg/sprite.svg#arrow2" /></svg></button>',
				nextArrow: '<button type="button" class="slick-next"><svg><use xlink:href="/common/svg/sprite.svg#arrow2" /></svg></button>',
			});
		}
	};
	const newsTab = () => {
		if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.desktop) {
			$('.js-spNewsTab').on('click', (e) => {
				let target = $(e.currentTarget).attr('data-target');
				$('.js-spNewsTab').removeClass(a);
				$(e.currentTarget).addClass(a);
				$('.js-spNewsTab-content').each((idx, ele) => {
					if ($(ele).attr('data-target') === target) {
						$(ele).addClass(a);
						setTimeout(() => { $(ele).addClass(v); });
					} else {
						$(ele).removeClass(a).removeClass(v);
					}
				});
			});
		}
	};
	const whatisSlider = () => {
		$('.top-whatis').find('.__slider').slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			speed: 1000,
			infinite: true,
			dots: false,
			arrows: true,
			nextArrow: '<button type="button" class="slick-next"><svg><use xlink:href="/common/svg/sprite.svg#arrow3" /></svg></button>',
			variableWidth: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						dots: true,
					}
				}
			]
		});
	};
	const exploringSlider = () => {
		if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.desktop) {
			$('.top-exploring').find('.__slider').slick({
				slidesToShow: 2,
				slidesToScroll: 1,
				autoplaySpeed: 6000,
				speed: 800,
				infinite: true,
				dots: true,
				arrows: false,
				variableWidth: true,
			});
		}
	};
	const setInstaList = () => {
		const maxNumber = 10;
		const instaBusinessId = '17841445568876147';
		const accessToken =
			'EAACPWWFKeMgBPKvDEueg8UV7dNaXAKMS50zBJPYkwBZB1z7xj76gVm8imwQHi2xeRsFbhi7wfvqIfml9MjQiZCNdkZAB0Fuv3veZBrOrVnOIkPmZAhKJuKoEyrkdVZA1LaKYwJTOj1SWPtlvx8jIySjbCTPiZBZC3ANh8Cf9QBt0hwQDSn89r9zZAS8sSkDaQoFTKNg0CCmkVzE456ZAHk';

		const instaJsonPath = `https://graph.facebook.com/v16.0/${instaBusinessId}` +
			`?fields=name%2Cmedia.limit(${maxNumber})%7Bmedia_url%2Cthumbnail_url%2Cpermalink%7D&access_token=${accessToken}`;
		// console.log(instaJsonPath);

		const setInstaSlider = () => {
			let minW;
			if (FUNCTIONS.va.window.width > 768) {
				minW = $('.top-sns .__insta .__head').width();
			} else {
				minW = FUNCTIONS.va.window.width / 2;
			}
			$('.js-instaList .__item').each((idx, ele) => { $(ele).css('height', minW); });
			$('.js-instaList .slick-list').css('height', minW);
		};

		let appendHTML = '';
		$.when(
			$.getJSON(instaJsonPath, (arr) => {
				const mediaData = arr.media.data;
				for (let i = 0; i < mediaData.length; i++) {
					appendHTML += `<div class="__item"><a href="${mediaData[i].permalink}" target="_blank" rel="noopener">`;
					if (!mediaData[i].thumbnail_url) {
						appendHTML += `<img src="${mediaData[i].media_url}" alt="" width="295" height="295" class="width-u-100"></a></div>`;
					} else {
						appendHTML += `<img src="${mediaData[i].thumbnail_url}" alt="" width="1080" height="1920" class="width-u-100"></a></div>`;
					}
				}
			})
		).done(() => {
			$('.js-instaList').append(appendHTML);
			$('.js-instaList').slick({
				slidesToShow: 5,
				slidesToScroll: 1,
				speed: 500,
				autoplay: true,
				autoplaySpeed: 5000,
				infinite: true,
				arrows: true,
				prevArrow: '<button type="button" class="slick-prev"><svg><use xlink:href="/common/svg/sprite.svg#arrow2" /></svg></button>',
				nextArrow: '<button type="button" class="slick-next"><svg><use xlink:href="/common/svg/sprite.svg#arrow2" /></svg></button>',
				dots: true,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 2,
						}
					}
				]
			});
			setInstaSlider();
			window.addEventListener('resize', setInstaSlider);
		});
	};
	const removeEmptyNews = () => {
		if (!$('.top-news .__event .__newsList').find('li').length && !$('.top-news .__info .__newsList').find('li').length) {
			$('.top-news').remove();
		}
	}

	mainVisSlider();
	newsBanner();
	newsTab();
	whatisSlider();
	exploringSlider();
	setInstaList();
	removeEmptyNews();

})(window.jQuery, window.FUNCTIONS);
